const formModal = document.querySelectorAll('.form-modal');

if (formModal.length > 0) {
  const toggleModal = (element, toggle) => {
    const parentElement = element.closest('[data-modal-parent]');
    const formModal = parentElement.querySelector('.form-modal');
    if (windowWidth() > breakpointMd) {
      document.body.classList.add('is-scrolled');
      document.body.classList.remove('is-scrolled-up');
    }
    formModal.classList.toggle('is-open-modal', toggle);
    toggleBodyScrollLock(toggle);
  };

  // Open Modal
  attachEvent('.form-modal-btn', 'click', (ev) => {
    toggleModal(ev.target, true);
    ev.preventDefault();
  });

  // Close Modal
  attachEvent('.form-modal__overlay,.form-modal__close', 'click', (ev) => {
    toggleModal(ev.target, false);

    if (windowWidth() > breakpointMd) {
      if (document.body.classList.contains('page-at-top')) {
        document.body.classList.add('is-scrolled-up');
        document.body.classList.remove('is-scrolled');
      }
    }

    ev.preventDefault();
  });

  // Close Modal on ESC key press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      formModal.forEach((ev) => {
        toggleModal(ev, false);

        if (windowWidth() > breakpointMd) {
          if (document.body.classList.contains('page-at-top')) {
            document.body.classList.add('is-scrolled-up');
            document.body.classList.remove('is-scrolled');
          }
        }
      });
    }
  });
}
